import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useAuth } from 'src/context/auth/use-auth';
import { consumeReturnTo } from 'src/utils/return-to';

const UnprotectedRoute = ({ children }: React.PropsWithChildren) => {
  const { inProgress, isSignedIn } = useAuth();
  const navigate = useNavigate();

  console.log(`UnprotectedRoute: ${inProgress}`);

  useEffect(() => {
    if (isSignedIn) {
      navigate(consumeReturnTo(), { replace: true });
    }
  }, [isSignedIn]);

  if (isSignedIn) return null;

  return children;
};

export default UnprotectedRoute;
